const ColumnConfigurationIcon = () => {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.375 0L3.49975 1.25H0V0H4.375ZM6.25 1.25H17.5V0H6.25V1.25ZM6.25 12.5H17.5V11.25H6.25V12.5ZM0 11.25V12.5H3.49975L4.375 11.25H0ZM6.25 6.875H17.5V5.625H6.25V6.875ZM0 5.625V6.875H3.49975L4.375 5.625H0Z"
        fill="#111113"
      />
    </svg>
  )
}

export default ColumnConfigurationIcon
